import { formatNumber } from "@/app/(app)/_lib/format";

type Props = {
  /** Integer count to display. Negative values are clamped to 0. */
  count: number;
};

/**
 * Compact count chip used in tables and cards (Hits, New, etc.).
 * - count &gt; 0 → green chip
 * - count &le; 0 → grey chip showing "0"
 */
export function CountChip({ count }: Props) {
  const value = Math.max(0, count);
  const positive = value > 0;
  return (
    <span
      className={[
        "inline-flex w-fit items-center rounded-[4px] px-2 py-0.5 text-tiny font-medium",
        positive ? "bg-green-100 text-green-700" : "bg-grey-100 text-grey-600",
      ].join(" ")}
    >
      {formatNumber(value)}
    </span>
  );
}
